module.exports = __webpack_public_path__ + "static/logo-db1e29c658a645961654d87611538e57.jpg";